import React, { FC } from 'react';
import { IsepStatusSectionProps } from './ISEPStatusSectionProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import SkappaCompleteSelect from '../SkappaCompleteSelect';

const IsepStatusSection: FC<IsepStatusSectionProps> = ({
  isepStatus,
  setIsepStatus,
}) => {
  const t = useTranslation();
  const options = t('ppm.isepStatuses');
  const historicalOptions = t('ppm.isepStatusesHistorical');
  const historicalOptionSelected = Object.keys(historicalOptions).find(
    (key) => key === isepStatus,
  );
  if (historicalOptionSelected) {
    options[isepStatus] = historicalOptions[isepStatus];
  }

  return (
    <Stack>
      <Text style={{ fontWeight: '700' }}>{'ISEP Status'}</Text>
      <SkappaCompleteSelect
        value={isepStatus}
        id={`isep-status-by-select`}
        label={null}
        onChange={setIsepStatus}
        options={options as unknown as { [key: string]: string }}
        disabledOption={historicalOptionSelected}
      />
    </Stack>
  );
};

export default IsepStatusSection;
